// external imports
import React from 'react'
// local imports
import leftControlImg from './left.png'
import rightControlImg from './right.png'
import styles from './styles'

const SlideControl = ({ side, ...unused }) => (
    <img
        src={side === 'left' ? leftControlImg : rightControlImg}
        style={side === 'left' ? styles.leftControl : styles.rightControl}
        {...unused}
    />
)

export default SlideControl



// WEBPACK FOOTER //
// ./src/components/Slideshow/Control/index.js